import { render } from "./PathwaysQuestionOtherImpair.vue?vue&type=template&id=0382aa84"
import script from "./PathwaysQuestionOtherImpair.vue?vue&type=script&lang=js"
export * from "./PathwaysQuestionOtherImpair.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__